import React, { useEffect } from 'react'
import HcnDetails from '../components/Confirmation/HcnDetails';
import { connect } from 'react-redux';
import { getOpenBookingDetails, hcnUpdateSubmit } from '../actions/hcnUpateAction';

const HcnUpdateContainer = (props) => {

    return (
        <div>
            <HcnDetails
                {...props}
                showPrice={true}
                showCancellation={false}
                showAgency={false}
            />
        </div>
    )
}
const mapStateToProps = (state) => {
    const { hcnUpdate = {} } = state;
    const { fetchingBookingDetails = false, bookingDetails = {}, hcnUpdateResponse = {}, updatingHcn = false } = hcnUpdate
    return { fetchingBookingDetails, bookingDetails, hcnUpdateResponse, updatingHcn }
},

    mapDispatchToProps = (dispatch) => ({
        getOpenBookingDetails: (payload) => {
            dispatch(getOpenBookingDetails(payload));
        },
        hcnUpdateSubmit: (payload) => {
            dispatch(hcnUpdateSubmit(payload));
        }
    });

export default connect(mapStateToProps, mapDispatchToProps)(HcnUpdateContainer);